'use strict';


angular.module('shiftTraderApp')
  .service('HomeCoordinator', ['$q', 'Session', 'TimeService', 'WorkPeriods', 'ShiftTradesResource', function($q, Session, TimeService, WorkPeriods, ShiftTradesResource) {
    var me = null;
    function getMe() {
      var deferred = $q.defer();

      if (me) {
        deferred.resolve(me);
      }

      Session.getMe()
        .then(function(data) {
          me = data;
          deferred.resolve(me);
        }, function(response) {
          console.log('Failed to load \'me\'.', response);
          deferred.reject(response);
        });

      return deferred.promise;
    }
    getMe();


    var data = {};

    function loadDayShifts(myWorkPeriods, dayTwix) {
      if (myWorkPeriods.length > 0) {
        var temp = lodash(myWorkPeriods).filter(function(wp) {
          return dayTwix.contains(wp.start_time);
        }).sortBy(function(wp) {
          return wp.start_time.unix();
        }).value();

        return temp;
      } else {
        return [];
      }
    }

    return {
      getDayOffRules: function(mmnt) {
        var deferred = $q.defer();

        // Check if the day off data is already present
        var dayKey = mmnt.format('MM-DD-YY');
        if (data[dayKey] && data[dayKey].daysOff) {
          deferred.resolve(data[dayKey].daysOff);
        } else {
          var dayTwix = TimeService.getDayTwixFromDate(mmnt);
          getMe()
            .then(function(me) {
              var rulesOnDate = lodash.filter(me.time_off_rules, function(rule) {
                return dayTwix.contains(rule.start);
              });

              if (!data[dayKey]) {
                data[dayKey] = {};
              }
              data[dayKey].daysOff = rulesOnDate;
              deferred.resolve(data[dayKey].daysOff);
            });
        }

        return deferred.promise;
      },
      getDayShifts: function(mmnt) {
        var deferred = $q.defer();

        // Check if data is already present
        var dayKey = mmnt.format('MM-DD-YY');
        if (data[dayKey] && data[dayKey].shifts) {
          deferred.resolve(data[dayKey].shifts);
        } else {
          var dayTwix = TimeService.getDayTwixFromDate(mmnt);
          getMe()
            .then(function(me) {
              var startTime = moment(mmnt).subtract(1, 'day').toISOString();
              WorkPeriods.getAll({
                user_id: me.id,
                start_time: startTime
              })
              .then(function(data) {
                var myWorkPeriods = lodash.filter(data, function(wp) {
                  return wp.$isPublished();
                });

                var dayShifts = loadDayShifts(myWorkPeriods, dayTwix) || [];
                if (!data[dayKey]) {
                  data[dayKey] = {};
                }
                data[dayKey].shifts = dayShifts;

                deferred.resolve(data[dayKey].shifts);
              }, function(response) {
                deferred.reject(response);
              });
            });
        }

        return deferred.promise;
      },
      getDayPickups: function(mmnt) {
        var deferred = $q.defer();

        // Check if the pickups data is already present
        var dayKey = mmnt.format('MM-DD-YY');
        if (data[dayKey] && data[dayKey].pickups) {
          deferred.resolve(data[dayKey].pickups);
        } else {
          var dayTwix = TimeService.getDayTwixFromDate(mmnt);
          getMe()
            .then(function(me) {
              ShiftTradesResource.query({ active: true }, function (trades) {
                lodash.each(trades, function(t) {
                  t.$initialize();
                });

                var availableGiveAways = lodash.filter(trades, function(t) {
                  return t.$isGiveaway() && t.user.id !== me.id  &&
                    !lodash.some(t.shift_trade_responses, function(resp) {
                      return _.include([10, 20, 21],resp.acceptance_code);
                    }) &&
                    t.$calculateActive(true) &&
                    dayTwix.contains(t.work_period.start_time) &&
                    t.work_period.$isQualifiedForPickup(me);
                });

                if (!data[dayKey]) {
                  data[dayKey] = {};
                }
                data[dayKey].pickups = availableGiveAways;
                deferred.resolve(data[dayKey].pickups);
              }, function (response) {
                console.log('Failed to retrieve trade records from server.');
                deferred.reject(response);
              });
            });
        }

        return deferred.promise;
      },
      getDayAvailability: function(mmnt) {
        var deferred = $q.defer();

        // Check if the availability data is already present
        var dayKey = mmnt.format('MM-DD-YY');
        if (data[dayKey] && data[dayKey].availability) {
          deferred.resolve(data[dayKey].availability);
        } else {
          getMe()
            .then(function(me) {
              var effectiveAvailabilitySet = me.$effectiveAvailabilitySet(mmnt);

              var dayOfWeek = mmnt.day();
              var rules = [];

              if (effectiveAvailabilitySet) {
                rules = lodash.filter(effectiveAvailabilitySet.availability_rules, function(rule) {
                  return rule.active && rule._type === 'weekly' && rule.day_of_week == dayOfWeek;
                });
              }

              if (!data[dayKey]) {
                data[dayKey] = {};
              }
              data[dayKey].availability = {
                availSet: effectiveAvailabilitySet,
                dayRules: rules
              };

              deferred.resolve(data[dayKey].availability);
            });
        }

        return deferred.promise;
      }
    };
  }]);
